import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import { List, Map } from 'immutable';
import { byValue, occurrence, ascending, descending } from '@Containers/ResultsFilters/ResultsFiltersConstants';
import GeneralDialogLayout from '@Containers/Dialogs/GeneralDialogLayout/GeneralDialogLayout';
import DialogContent from '@Containers/ResultsFilters/ResultsFiltersComponents/NewAuthorCheckboxesDialog/Components/DialogContent';
import DialogFooter from '@Containers/ResultsFilters/ResultsFiltersComponents/NewAuthorCheckboxesDialog/Components/DialogFooter';
import './NewAuthorCheckboxesDialog.custom.scss';
import './NewAuthorCheckboxesDialog.theme.scss';

function NewAuthorCheckboxesDialog(props) {
  const { filterTitle, className } = props;

  return (
    <GeneralDialogLayout
      {...props}
      className={cn(className, 'new-author-checkboxes-dialog')}
      headerClassName="new-author-checkboxes-dialog__header"
      header={<h4>{filterTitle}</h4>}
      contentClassName="new-author-checkboxes-dialog__content"
      footerClassName="new-author-checkboxes-dialog__footer"
      footer={<DialogFooter {...props} />}>
      <DialogContent {...props} />
    </GeneralDialogLayout>
  );
}

NewAuthorCheckboxesDialog.propTypes = {
  id: PropTypes.string,
  className: PropTypes.string,
  filter: PropTypes.instanceOf(Map),
  filterTitle: PropTypes.string,
  sortingType: PropTypes.oneOf([occurrence, byValue]),
  sorting: PropTypes.oneOf([ascending, descending]),
  activeChunk: PropTypes.instanceOf(List),
  selectedCount: PropTypes.number,
  disableClearSelected: PropTypes.bool,
  onCheckboxClick: PropTypes.func.isRequired,
  onClickClearSelected: PropTypes.func.isRequired,
  onDescending: PropTypes.func.isRequired,
  disableDescending: PropTypes.bool,
  onAscending: PropTypes.func.isRequired,
  disableAscending: PropTypes.bool,
  onOccurrence: PropTypes.func.isRequired,
  onByValue: PropTypes.func.isRequired,
  customGroupsWithByValueSorting: PropTypes.bool,
  customGroupsData: PropTypes.array,
  activeCustomGroupIndex: PropTypes.string,
  setActiveCustomGroupIndex: PropTypes.func,
  isAuthorsOfSciDocFilter: PropTypes.bool,
  chunksCount: PropTypes.number,
  onClickLimitTo: PropTypes.func.isRequired,
  onClickExclude: PropTypes.func.isRequired,
  disableLimitTo: PropTypes.bool,
  disableExclude: PropTypes.bool,
  setActiveChunkId: PropTypes.func.isRequired,
  onClickGoToButton: PropTypes.func.isRequired,
  activeChunkIndexAsInteger: PropTypes.number.isRequired,
  customGroups: PropTypes.bool,
  openAffiliationFilter: PropTypes.func,
};

export default NewAuthorCheckboxesDialog;
